import {IPublicClientApplication} from '@azure/msal-browser'

export const setDefaultAccount = (instance: IPublicClientApplication) => {
    // Default to using the first account if no account is active on page load
    if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        instance.setActiveAccount(instance.getAllAccounts()[0])
    }
}

export const getEmailFromMsal = (msalInstance: IPublicClientApplication) => {
    return msalInstance?.getActiveAccount()?.username
}


